import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAttributesInfo } from "../interfaces/attributes";
import { ICoreElementProperties, IElementAPIPropertiesResponse, IElementKindInfo, IElementPeriodInfo, IElementScopeInfo, IElementsInfo } from "../interfaces/elements";
import { IGameMainFields } from "../interfaces/game-info";
import { IGamePropertiesState } from "../interfaces/slices";
import { ITeamsInfo } from "../interfaces/teams";

const initialState: IGamePropertiesState = {
    teams: {},
    attributes: {},
    elements: {},
    kind: {},
    period: {},
    scope: {},
    mainGameFieldValidations: [],
    elementPropertiesValidations: {},
    attributePropertiesValidations: {
        id: '',
        min: 0,
        max: 0,
        fields: []
    }
}

export const gamePropertiesSlice = createSlice({
    name: 'gameProperties',
    initialState,
    reducers: {
        addTeamsList: (state, action: PayloadAction<Array<ITeamsInfo>>) => {
            state.teams = {};
            action.payload.forEach((info: ITeamsInfo) => {
                state.teams[info.id] = info;
            })
        },
        addAttributesList: (state, action: PayloadAction<Array<IAttributesInfo>>) => {
            state.attributes = {};
            action.payload.forEach((info: IAttributesInfo) => {
                state.attributes[info.id] = info;
            })
        },
        addElementsList: (state, action: PayloadAction<Array<IElementsInfo>>) => {
            state.elements = {};
            action.payload.forEach((info: IElementsInfo) => {
                state.elements[info.id] = info;
            })
        },
        addElementPropertiesInfo: (state, action: PayloadAction<IElementAPIPropertiesResponse>) => {
            state.elementPropertiesValidations = {};
            Object.entries(action.payload).forEach((item: [string, ICoreElementProperties | Array<IGameMainFields>], index: number) => {
                if (item[0] === 'fields') {
                    state.mainGameFieldValidations = item[1] as Array<IGameMainFields>;
                }
                else {
                    state.elementPropertiesValidations[(item[1] as ICoreElementProperties).id] = item[1] as ICoreElementProperties;
                }
            });
        },
        addAttributesPropertiesInfo: (state, action: PayloadAction<ICoreElementProperties>) => {
            state.attributePropertiesValidations.id = action.payload.id;
            state.attributePropertiesValidations.min = action.payload.min;
            state.attributePropertiesValidations.max = action.payload.max;
            state.attributePropertiesValidations.fields = action.payload.fields;
        },
        addKindInfo: (state, action: PayloadAction<Array<IElementKindInfo>>) => {
            state.kind = {};
            action.payload.forEach((item: IElementKindInfo) => {
                state.kind[item.id] = item;
            });
        },
        addPeriodInfo: (state, action: PayloadAction<Array<IElementPeriodInfo>>) => {
            state.period = {};
            action.payload.forEach((item: IElementPeriodInfo) => {
                state.period[item.id] = item;
            });
        },
        addScopeInfo: (state, action: PayloadAction<Array<IElementScopeInfo>>) => {
            state.scope = {};
            action.payload.forEach((item: IElementScopeInfo) => {
                state.scope[item.id] = item;
            });
        },
    },
})

export const { addTeamsList, addAttributesList, addElementsList, addElementPropertiesInfo, addAttributesPropertiesInfo, addKindInfo, addPeriodInfo, addScopeInfo } = gamePropertiesSlice.actions
export default gamePropertiesSlice.reducer;